<button
  pButton
  type="button"
  class="atlas-btn atlas-btn-default"
  icon="pi pi-copy"
  [disabled]="userAccessLevel < 2"
  (click)="dulplicateClick()"
></button>

<p-dialog
  #eventCopyModal
  modal="true"
  [(visible)]="showModal"
  [closable]="false"
  styleClass="atlas-dialog-s"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header">
    {{ 'events.copy.component.title' | translate | titlecase }}
  </ng-template>
  <div class="container-fluid">
    <div class="row">
      <label>
        {{ 'events.copy.component.event-start-date-label' | translate | titlecase }}
      </label>
      <div><wl-date-selector name="date" [(ngModel)]="eventCopy.NewStartDate"></wl-date-selector></div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-primary"
      icon="pi pi-copy"
      [label]="'common.ok' | translate | titlecase"
      (click)="copyEvent()"
    ></button>
    <cancel-button [label]="'common.cancel' | translate | titlecase" (onClick)="cancelClick()"> </cancel-button>
  </ng-template>
</p-dialog>

<p-confirmDialog
  #cd
  key="invalidCustomFieldsCDCopy"
  header="{{ 'common.warning' | translate | ucfirst }}"
  icon="pi pi-exclamation-triangle"
  styleClass="atlas-dialog-s text-left"
>
  <p-footer>
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="cd.onReject()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
  </p-footer>
</p-confirmDialog>
